
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Accessibility = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Accessibility Statement</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">Last updated: January 2025</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Our Commitment to Accessibility</h2>
            <p className="text-gray-700 mb-4">
              GoldenTicketLucky is committed to ensuring digital accessibility for people with disabilities. 
              We are continually improving the user experience for everyone and applying the relevant 
              accessibility standards.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Conformance Status</h2>
            <p className="text-gray-700 mb-4">
              The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and 
              developers to improve accessibility for people with disabilities. It defines three levels 
              of conformance: Level A, Level AA, and Level AAA. GoldenTicketLucky is partially conformant 
              with WCAG 2.1 level AA.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Accessibility Features</h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Keyboard navigation support</li>
              <li>Screen reader compatibility</li>
              <li>High contrast color schemes</li>
              <li>Scalable text and images</li>
              <li>Alternative text for images</li>
              <li>Descriptive link text</li>
              <li>Logical heading structure</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Known Issues</h2>
            <p className="text-gray-700 mb-4">
              We are aware of some accessibility issues and are working to address them:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Some interactive elements may not have sufficient color contrast</li>
              <li>Live lottery results may not be announced to screen readers</li>
              <li>Some form validation messages may not be properly associated</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Assistive Technologies</h2>
            <p className="text-gray-700 mb-4">
              Our website is designed to be compatible with:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Screen readers (JAWS, NVDA, VoiceOver)</li>
              <li>Voice recognition software</li>
              <li>Browser zoom up to 200%</li>
              <li>Keyboard-only navigation</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you encounter any accessibility barriers on our website, please contact us:
            </p>
            <ul className="list-none text-gray-700 mb-4">
              <li>Email: accessibility@goldenticketlucky.com</li>
              <li>Phone: 1800 GOLDEN (+61359294105)</li>
              <li>Address: 24 Balmoral Ave, Springvale VIC 3171</li>
            </ul>
            
            <div className="bg-blue-50 p-6 rounded-lg mt-8">
              <p className="text-gray-700 font-medium">
                We welcome your feedback on the accessibility of GoldenTicketLucky. Please let us know 
                if you encounter accessibility barriers and we will work to improve the experience 
                for all users.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Accessibility;
